import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';

type EmptyStateVariants =
  | 'add-data'
  | 'empty-object-light'
  | 'no-access'
  | 'no-data'
  | 'no-document'
  | 'not-found';

@Component({
  selector: 'app-empty-state',
  template: `
    <img [ngSrc]="'/assets/img/' + image() + '.svg'" width="130" height="130" priority />
    @if (title()) {
      <h5 class="app-empty-state__title">{{ title() }}</h5>
    }
    @if (description()) {
      <p class="app-empty-state__description">{{ description() }}</p>
    }
  `,
  styleUrl: './empty-state.component.scss',
  imports: [NgOptimizedImage],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'app-empty-state',
  },
})
export class EmptyStateComponent {
  readonly title = input('');
  readonly description = input('');
  readonly image = input<EmptyStateVariants>('no-document');
}
